module.exports = __webpack_public_path__ + "media/Images/TriangleBlue-5ce45c74.svg";